/* @generated from adl module hotel.db */

import * as ADL from './../runtime/adl';
import * as common from './../common';
import * as common_db from './../common/db';
import * as common_strings from './../common/strings';
import * as hotel_booking from './booking';
import * as hotel_common from './common';
import * as ids_common from './../ids/common';

/**
 * Details for a user
 */
export interface AppUser {
  userType: AppUserType;
  fullname: common_strings.StringNE;
  email: common_strings.StringNE;
  hashedPassword: common_strings.StringNE;
  /**
   * Status of the user.
   */
  userStatus: UserStatus;
  /**
   * Id of agency associated with this user, if present.
   */
  agencyId: (common_db.DbKey<Agency>|null);
  /**
   * Phone number of user if present.
   */
  phoneNumber: (ids_common.PhoneNumber|null);
  /**
   * Overriding commission percentage if present (for agents).
   */
  commissionPercentage: (common.BigDecimal|null);
  /**
   * Invite hash if present.
   */
  inviteHash: (common_strings.StringNE|null);
  /**
   * When invite hash expires, if present.
   */
  inviteHashExpiryTime: (common.Instant|null);
}

export function makeAppUser(
  input: {
    userType: AppUserType,
    fullname: common_strings.StringNE,
    email: common_strings.StringNE,
    hashedPassword?: common_strings.StringNE,
    userStatus: UserStatus,
    agencyId?: (common_db.DbKey<Agency>|null),
    phoneNumber?: (ids_common.PhoneNumber|null),
    commissionPercentage?: (common.BigDecimal|null),
    inviteHash?: (common_strings.StringNE|null),
    inviteHashExpiryTime?: (common.Instant|null),
  }
): AppUser {
  return {
    userType: input.userType,
    fullname: input.fullname,
    email: input.email,
    hashedPassword: input.hashedPassword === undefined ? "" : input.hashedPassword,
    userStatus: input.userStatus,
    agencyId: input.agencyId === undefined ? null : input.agencyId,
    phoneNumber: input.phoneNumber === undefined ? null : input.phoneNumber,
    commissionPercentage: input.commissionPercentage === undefined ? null : input.commissionPercentage,
    inviteHash: input.inviteHash === undefined ? null : input.inviteHash,
    inviteHashExpiryTime: input.inviteHashExpiryTime === undefined ? null : input.inviteHashExpiryTime,
  };
}

const AppUser_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["email","agencyId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details for a user\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userType","default":{"kind":"nothing"},"name":"userType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUserType"}},"parameters":[]}},{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"hashedPassword","default":{"kind":"just","value":""},"name":"hashedPassword","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Status of the user.\n"}],"serializedName":"userStatus","default":{"kind":"nothing"},"name":"userStatus","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"UserStatus"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of agency associated with this user, if present.\n"}],"serializedName":"agencyId","default":{"kind":"just","value":null},"name":"agencyId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Agency"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Phone number of user if present.\n"}],"serializedName":"phoneNumber","default":{"kind":"just","value":null},"name":"phoneNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNumber"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Overriding commission percentage if present (for agents).\n"}],"serializedName":"commissionPercentage","default":{"kind":"just","value":null},"name":"commissionPercentage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Invite hash if present.\n"}],"serializedName":"inviteHash","default":{"kind":"just","value":null},"name":"inviteHash","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When invite hash expires, if present.\n"}],"serializedName":"inviteHashExpiryTime","default":{"kind":"just","value":null},"name":"inviteHashExpiryTime","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}}]}},"name":"AppUser","version":{"kind":"nothing"}}};

export const snAppUser: ADL.ScopedName = {moduleName:"hotel.db", name:"AppUser"};

export function texprAppUser(): ADL.ATypeExpr<AppUser> {
  return {value : {typeRef : {kind: "reference", value : snAppUser}, parameters : []}};
}

export enum UserStatus {
  deactivated,
  deleted,
  activated,
  pending,
}

const UserStatus_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"User has been deactivated and can no longer access their account but will still be seen\nin the list of users on the agency users management screen.\n"}],"serializedName":"deactivated","default":{"kind":"nothing"},"name":"deactivated","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"User has been deleted and can no longer access their account and will be hidden from the list\nof users on the agency users management screen.\n"}],"serializedName":"deleted","default":{"kind":"nothing"},"name":"deleted","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"User is active.\n"}],"serializedName":"activated","default":{"kind":"nothing"},"name":"activated","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"User has been sent an invite via email but has not yet confirmed their account.\n"}],"serializedName":"pending","default":{"kind":"nothing"},"name":"pending","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"UserStatus","version":{"kind":"nothing"}}};

export const snUserStatus: ADL.ScopedName = {moduleName:"hotel.db", name:"UserStatus"};

export function texprUserStatus(): ADL.ATypeExpr<UserStatus> {
  return {value : {typeRef : {kind: "reference", value : snUserStatus}, parameters : []}};
}

export type AppUserId = common_db.DbKey<AppUser>;

const AppUserId_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUser"}},"parameters":[]}]}}},"name":"AppUserId","version":{"kind":"nothing"}}};

export const snAppUserId: ADL.ScopedName = {moduleName:"hotel.db", name:"AppUserId"};

export function texprAppUserId(): ADL.ATypeExpr<AppUserId> {
  return {value : {typeRef : {kind: "reference", value : snAppUserId}, parameters : []}};
}

export enum AppUserType {
  admin,
  backOffice,
  agencyAdmin,
  agent,
}

const AppUserType_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Types of app users.\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Site admin.\n"}],"serializedName":"admin","default":{"kind":"nothing"},"name":"admin","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Back office admin.\n"}],"serializedName":"backOffice","default":{"kind":"nothing"},"name":"backOffice","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Admin of an agency, can add/remove agents in their office.\n"}],"serializedName":"agencyAdmin","default":{"kind":"nothing"},"name":"agencyAdmin","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Agents of an agency.\n"}],"serializedName":"agent","default":{"kind":"nothing"},"name":"agent","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"AppUserType","version":{"kind":"nothing"}}};

export const snAppUserType: ADL.ScopedName = {moduleName:"hotel.db", name:"AppUserType"};

export function texprAppUserType(): ADL.ATypeExpr<AppUserType> {
  return {value : {typeRef : {kind: "reference", value : snAppUserType}, parameters : []}};
}

/**
 * Log records relating to activity on the app user table.
 */
export interface AppUserLog {
  /**
   * User id associated with this log record.
   */
  userId: common_db.DbKey<AppUser>;
  /**
   * When the activity occurred.
   */
  timestamp: common.Instant;
  /**
   * The logged in user responsible (if any).
   */
  loggedInUserId: common_db.DbKey<AppUser>;
  /**
   * From where the request eventuated
   */
  remoteAddress: hotel_common.IpAddress;
  /**
   * A textual description of the change.
   */
  description: string;
  /**
   * Transaction details (typically the originating request).
   */
  details: {}|null;
}

export function makeAppUserLog(
  input: {
    userId: common_db.DbKey<AppUser>,
    timestamp: common.Instant,
    loggedInUserId: common_db.DbKey<AppUser>,
    remoteAddress?: hotel_common.IpAddress,
    description: string,
    details?: {}|null,
  }
): AppUserLog {
  return {
    userId: input.userId,
    timestamp: input.timestamp,
    loggedInUserId: input.loggedInUserId,
    remoteAddress: input.remoteAddress === undefined ? "" : input.remoteAddress,
    description: input.description,
    details: input.details === undefined ? null : input.details,
  };
}

const AppUserLog_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["userId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Log records relating to activity on the app user table.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"User id associated with this log record.\n"}],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the activity occurred.\n"}],"serializedName":"timestamp","default":{"kind":"nothing"},"name":"timestamp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The logged in user responsible (if any).\n"}],"serializedName":"loggedInUserId","default":{"kind":"nothing"},"name":"loggedInUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"From where the request eventuated\n"}],"serializedName":"remoteAddress","default":{"kind":"just","value":""},"name":"remoteAddress","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"IpAddress"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A textual description of the change.\n"}],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Transaction details (typically the originating request).\n"}],"serializedName":"details","default":{"kind":"just","value":null},"name":"details","typeExpr":{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}}]}},"name":"AppUserLog","version":{"kind":"nothing"}}};

export const snAppUserLog: ADL.ScopedName = {moduleName:"hotel.db", name:"AppUserLog"};

export function texprAppUserLog(): ADL.ATypeExpr<AppUserLog> {
  return {value : {typeRef : {kind: "reference", value : snAppUserLog}, parameters : []}};
}

export interface HeadOffice {
  /**
   * Name of head office.
   */
  name: common_strings.StringNE;
  /**
   * Email address of head office contact.
   */
  emailAddress: common_strings.EmailAddress;
  /**
   * The head office's phone number.
   */
  phoneNumber: ids_common.PhoneNumber;
  /**
   * Address of head office.
   */
  address: ids_common.Address;
  /**
   * Timezone of head office.
   */
  timezone: common.Timezone;
  /**
   * Takes commission
   */
  takesCommission: boolean;
  /**
   * Bank account details associated with head office, if present
   */
  bankAccountDetails: (hotel_common.BankAccountDetails|null);
  /**
   * Link to another head office above this one
   */
  superHeadOffice: (common_db.DbKey<HeadOffice>|null);
}

export function makeHeadOffice(
  input: {
    name: common_strings.StringNE,
    emailAddress: common_strings.EmailAddress,
    phoneNumber: ids_common.PhoneNumber,
    address: ids_common.Address,
    timezone: common.Timezone,
    takesCommission: boolean,
    bankAccountDetails: (hotel_common.BankAccountDetails|null),
    superHeadOffice: (common_db.DbKey<HeadOffice>|null),
  }
): HeadOffice {
  return {
    name: input.name,
    emailAddress: input.emailAddress,
    phoneNumber: input.phoneNumber,
    address: input.address,
    timezone: input.timezone,
    takesCommission: input.takesCommission,
    bankAccountDetails: input.bankAccountDetails,
    superHeadOffice: input.superHeadOffice,
  };
}

const HeadOffice_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of head office.\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Email address of head office contact.\n"}],"serializedName":"emailAddress","default":{"kind":"nothing"},"name":"emailAddress","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The head office's phone number.\n"}],"serializedName":"phoneNumber","default":{"kind":"nothing"},"name":"phoneNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNumber"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Address of head office.\n"}],"serializedName":"address","default":{"kind":"nothing"},"name":"address","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"Address"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Timezone of head office.\n"}],"serializedName":"timezone","default":{"kind":"nothing"},"name":"timezone","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Timezone"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Takes commission\n"}],"serializedName":"takesCommission","default":{"kind":"nothing"},"name":"takesCommission","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Bank account details associated with head office, if present\n"}],"serializedName":"bankAccountDetails","default":{"kind":"nothing"},"name":"bankAccountDetails","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"BankAccountDetails"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Link to another head office above this one\n"}],"serializedName":"superHeadOffice","default":{"kind":"nothing"},"name":"superHeadOffice","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"HeadOffice"}},"parameters":[]}]}]}}]}},"name":"HeadOffice","version":{"kind":"nothing"}}};

export const snHeadOffice: ADL.ScopedName = {moduleName:"hotel.db", name:"HeadOffice"};

export function texprHeadOffice(): ADL.ATypeExpr<HeadOffice> {
  return {value : {typeRef : {kind: "reference", value : snHeadOffice}, parameters : []}};
}

/**
 * Represents a travel agency office.
 */
export interface Agency {
  /**
   * Name of agency.
   */
  name: common_strings.StringNE;
  /**
   * Email address of agency.
   */
  emailAddress: common_strings.EmailAddress;
  /**
   * The agency's phone number.
   */
  phoneNumber: ids_common.PhoneNumber;
  /**
   * Address of agency.
   */
  address: ids_common.Address;
  /**
   * Timezone of agency.
   */
  timezone: common.Timezone;
  /**
   * Default agency-wide commission percentage.
   */
  commissionPercentage: common.BigDecimal;
  /**
   * Bank account details associated with agency, if present
   */
  bankAccountDetails: (hotel_common.BankAccountDetails|null);
  /**
   * Head office of Agency
   */
  headOffice: (common_db.DbKey<HeadOffice>|null);
  /**
   * Currency agency is using
   */
  currency: hotel_common.Currency;
  /**
   * Key contact for the agency's name.
   */
  keyContactName: common_strings.StringNE;
  /**
   * Key contact for the agency's phone number.
   */
  keyContactPhoneNumber: ids_common.PhoneNumber;
  /**
   * Key contact for the agency's email address, if present.
   */
  keyContactEmailAddress: (common_strings.EmailAddress|null);
}

export function makeAgency(
  input: {
    name: common_strings.StringNE,
    emailAddress: common_strings.EmailAddress,
    phoneNumber: ids_common.PhoneNumber,
    address: ids_common.Address,
    timezone: common.Timezone,
    commissionPercentage: common.BigDecimal,
    bankAccountDetails: (hotel_common.BankAccountDetails|null),
    headOffice: (common_db.DbKey<HeadOffice>|null),
    currency: hotel_common.Currency,
    keyContactName: common_strings.StringNE,
    keyContactPhoneNumber: ids_common.PhoneNumber,
    keyContactEmailAddress: (common_strings.EmailAddress|null),
  }
): Agency {
  return {
    name: input.name,
    emailAddress: input.emailAddress,
    phoneNumber: input.phoneNumber,
    address: input.address,
    timezone: input.timezone,
    commissionPercentage: input.commissionPercentage,
    bankAccountDetails: input.bankAccountDetails,
    headOffice: input.headOffice,
    currency: input.currency,
    keyContactName: input.keyContactName,
    keyContactPhoneNumber: input.keyContactPhoneNumber,
    keyContactEmailAddress: input.keyContactEmailAddress,
  };
}

const Agency_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a travel agency office.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of agency.\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Email address of agency.\n"}],"serializedName":"emailAddress","default":{"kind":"nothing"},"name":"emailAddress","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The agency's phone number.\n"}],"serializedName":"phoneNumber","default":{"kind":"nothing"},"name":"phoneNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNumber"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Address of agency.\n"}],"serializedName":"address","default":{"kind":"nothing"},"name":"address","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"Address"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Timezone of agency.\n"}],"serializedName":"timezone","default":{"kind":"nothing"},"name":"timezone","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Timezone"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Default agency-wide commission percentage.\n"}],"serializedName":"commissionPercentage","default":{"kind":"nothing"},"name":"commissionPercentage","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Bank account details associated with agency, if present\n"}],"serializedName":"bankAccountDetails","default":{"kind":"nothing"},"name":"bankAccountDetails","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"BankAccountDetails"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Head office of Agency\n"}],"serializedName":"headOffice","default":{"kind":"nothing"},"name":"headOffice","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"HeadOffice"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Currency agency is using\n"}],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"Currency"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Key contact for the agency's name.\n"}],"serializedName":"keyContactName","default":{"kind":"nothing"},"name":"keyContactName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Key contact for the agency's phone number.\n"}],"serializedName":"keyContactPhoneNumber","default":{"kind":"nothing"},"name":"keyContactPhoneNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNumber"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Key contact for the agency's email address, if present.\n"}],"serializedName":"keyContactEmailAddress","default":{"kind":"nothing"},"name":"keyContactEmailAddress","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}]}}]}},"name":"Agency","version":{"kind":"nothing"}}};

export const snAgency: ADL.ScopedName = {moduleName:"hotel.db", name:"Agency"};

export function texprAgency(): ADL.ATypeExpr<Agency> {
  return {value : {typeRef : {kind: "reference", value : snAgency}, parameters : []}};
}

/**
 * Log records relating to activity on the agency table.
 */
export interface AgencyLog {
  /**
   * Agency id associated with this log record.
   */
  agencyId: common_db.DbKey<Agency>;
  /**
   * When the activity occurred.
   */
  timestamp: common.Instant;
  /**
   * The logged in user responsible (if any).
   */
  loggedInUserId: common_db.DbKey<AppUser>;
  /**
   * From where the request eventuated
   */
  remoteAddress: hotel_common.IpAddress;
  /**
   * A textual description of the change.
   */
  description: string;
  /**
   * Transaction details (typically the originating request).
   */
  details: {}|null;
}

export function makeAgencyLog(
  input: {
    agencyId: common_db.DbKey<Agency>,
    timestamp: common.Instant,
    loggedInUserId: common_db.DbKey<AppUser>,
    remoteAddress?: hotel_common.IpAddress,
    description: string,
    details?: {}|null,
  }
): AgencyLog {
  return {
    agencyId: input.agencyId,
    timestamp: input.timestamp,
    loggedInUserId: input.loggedInUserId,
    remoteAddress: input.remoteAddress === undefined ? "" : input.remoteAddress,
    description: input.description,
    details: input.details === undefined ? null : input.details,
  };
}

const AgencyLog_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["agencyId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Log records relating to activity on the agency table.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Agency id associated with this log record.\n"}],"serializedName":"agencyId","default":{"kind":"nothing"},"name":"agencyId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Agency"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the activity occurred.\n"}],"serializedName":"timestamp","default":{"kind":"nothing"},"name":"timestamp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The logged in user responsible (if any).\n"}],"serializedName":"loggedInUserId","default":{"kind":"nothing"},"name":"loggedInUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"From where the request eventuated\n"}],"serializedName":"remoteAddress","default":{"kind":"just","value":""},"name":"remoteAddress","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"IpAddress"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A textual description of the change.\n"}],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Transaction details (typically the originating request).\n"}],"serializedName":"details","default":{"kind":"just","value":null},"name":"details","typeExpr":{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}}]}},"name":"AgencyLog","version":{"kind":"nothing"}}};

export const snAgencyLog: ADL.ScopedName = {moduleName:"hotel.db", name:"AgencyLog"};

export function texprAgencyLog(): ADL.ATypeExpr<AgencyLog> {
  return {value : {typeRef : {kind: "reference", value : snAgencyLog}, parameters : []}};
}

/**
 * An itinerary represents an itinerary of bookings for a trip.
 */
export interface Itinerary {
  /**
   * Generated unique short itinerary number
   */
  itineraryNumber: common_strings.StringNE;
  /**
   * Description of itinerary
   */
  description: (common_strings.StringNE|null);
  /**
   * Id of user (must be an agent) associated with this itinerary.
   */
  userId: common_db.DbKey<AppUser>;
}

export function makeItinerary(
  input: {
    itineraryNumber: common_strings.StringNE,
    description: (common_strings.StringNE|null),
    userId: common_db.DbKey<AppUser>,
  }
): Itinerary {
  return {
    itineraryNumber: input.itineraryNumber,
    description: input.description,
    userId: input.userId,
  };
}

const Itinerary_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["userId"]],"uniquenessConstraints":[["itineraryNumber"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An itinerary represents an itinerary of bookings for a trip.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Generated unique short itinerary number\n"}],"serializedName":"itineraryNumber","default":{"kind":"nothing"},"name":"itineraryNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Description of itinerary\n"}],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of user (must be an agent) associated with this itinerary.\n"}],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUser"}},"parameters":[]}]}}]}},"name":"Itinerary","version":{"kind":"nothing"}}};

export const snItinerary: ADL.ScopedName = {moduleName:"hotel.db", name:"Itinerary"};

export function texprItinerary(): ADL.ATypeExpr<Itinerary> {
  return {value : {typeRef : {kind: "reference", value : snItinerary}, parameters : []}};
}

/**
 * Log records relating to activity on an itinerary including
 * bookings being added to/deleted from the itinerary,
 * change in agency user, description, passenger details etc.
 */
export interface ItineraryLog {
  /**
   * Itinerary associated with this log record.
   */
  itineraryId: common_db.DbKey<Itinerary>;
  /**
   * When the activity occurred.
   */
  timestamp: common.Instant;
  /**
   * The logged in user responsible (if any).
   */
  userId: common_db.DbKey<AppUser>;
  /**
   * From where the request eventuated
   */
  remoteAddress: hotel_common.IpAddress;
  /**
   * A textual description of the change.
   */
  description: string;
  /**
   * Transaction details (typically the originating request).
   */
  details: {}|null;
}

export function makeItineraryLog(
  input: {
    itineraryId: common_db.DbKey<Itinerary>,
    timestamp: common.Instant,
    userId: common_db.DbKey<AppUser>,
    remoteAddress?: hotel_common.IpAddress,
    description: string,
    details?: {}|null,
  }
): ItineraryLog {
  return {
    itineraryId: input.itineraryId,
    timestamp: input.timestamp,
    userId: input.userId,
    remoteAddress: input.remoteAddress === undefined ? "" : input.remoteAddress,
    description: input.description,
    details: input.details === undefined ? null : input.details,
  };
}

const ItineraryLog_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["itineraryId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Log records relating to activity on an itinerary including\nbookings being added to/deleted from the itinerary,\nchange in agency user, description, passenger details etc.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Itinerary associated with this log record.\n"}],"serializedName":"itineraryId","default":{"kind":"nothing"},"name":"itineraryId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Itinerary"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the activity occurred.\n"}],"serializedName":"timestamp","default":{"kind":"nothing"},"name":"timestamp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The logged in user responsible (if any).\n"}],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"From where the request eventuated\n"}],"serializedName":"remoteAddress","default":{"kind":"just","value":""},"name":"remoteAddress","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"IpAddress"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A textual description of the change.\n"}],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Transaction details (typically the originating request).\n"}],"serializedName":"details","default":{"kind":"just","value":null},"name":"details","typeExpr":{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}}]}},"name":"ItineraryLog","version":{"kind":"nothing"}}};

export const snItineraryLog: ADL.ScopedName = {moduleName:"hotel.db", name:"ItineraryLog"};

export function texprItineraryLog(): ADL.ATypeExpr<ItineraryLog> {
  return {value : {typeRef : {kind: "reference", value : snItineraryLog}, parameters : []}};
}

/**
 * Stores itinerary numbers that have been used in the current year
 * and unique itinerary numbers available to use next.
 */
export interface ItineraryNumber {
  /**
   * Unique itinerary number.
   */
  itineraryNumber: common_strings.StringNE;
  /**
   * Whether the itinerary number has been used.
   */
  isUsed: boolean;
}

export function makeItineraryNumber(
  input: {
    itineraryNumber: common_strings.StringNE,
    isUsed: boolean,
  }
): ItineraryNumber {
  return {
    itineraryNumber: input.itineraryNumber,
    isUsed: input.isUsed,
  };
}

const ItineraryNumber_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["itineraryNumber"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Stores itinerary numbers that have been used in the current year\nand unique itinerary numbers available to use next.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Unique itinerary number.\n"}],"serializedName":"itineraryNumber","default":{"kind":"nothing"},"name":"itineraryNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Whether the itinerary number has been used.\n"}],"serializedName":"isUsed","default":{"kind":"nothing"},"name":"isUsed","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"ItineraryNumber","version":{"kind":"nothing"}}};

export const snItineraryNumber: ADL.ScopedName = {moduleName:"hotel.db", name:"ItineraryNumber"};

export function texprItineraryNumber(): ADL.ATypeExpr<ItineraryNumber> {
  return {value : {typeRef : {kind: "reference", value : snItineraryNumber}, parameters : []}};
}

/**
 * Represents a booking on an itinerary.
 */
export interface Booking {
  /**
   * Generated unique short booking number
   */
  bookingNumber: common_strings.StringNE;
  /**
   * Details about hotel.
   */
  hotelDetails: hotel_booking.HotelDetails;
  /**
   * Id of itinerary this booking is associated with.
   */
  itineraryId: common_db.DbKey<Itinerary>;
  /**
   * Id of supplier for this hotel to generate link to supplier page
   * on IDS for backoffice users.
   */
  supplierId: hotel_common.SupplierId;
  /**
   * Supplier hotel id which can be used to generate a link to the
   * supplier hotel page on IDS (with the supplierId).
   */
  supplierHotelId: hotel_common.SupplierHotelId;
  /**
   * Id of hotel to generate link to hotel page on IDS for backoffice users.
   */
  hotelId: hotel_common.HotelId;
  /**
   * Contains supplier information about this booking, i.e booking ID,
   * reference, etc. Present if the booking is confirmed
   */
  supplierBookingInfo: ({}|null|null);
  /**
   * Supplier room id
   * Note: Despite Gimmonix documentation, there is no Room Id. There is only Package Id and
   * PackageRoom Id which are generated ids. The roomKey seems to be the only id we can use to
   * refresh and pay for an existing draft/quote booking in different hotel searches. The roomKey
   * is optional as there might not exist one in Gimmonix packages
   */
  supplierHotelRoomId: (string|null);
  /**
   * Id of hotel room, if we have been able to match this room to the one the supplier
   * provided.
   */
  hotelRoomId: (hotel_common.HotelRoomId|null);
  /**
   * Name of room (from supplier).
   */
  roomName: common_strings.StringNE;
  /**
   * Board description e.g. Room Only, Breakfast Included etc.
   */
  board: hotel_booking.Board;
  /**
   * Represents the current status of this booking.
   */
  liveStatus: hotel_booking.LiveStatus;
  /**
   * Represents the current status of the client payment for this booking.
   */
  clientPaymentStatus: hotel_booking.ClientPaymentStatus;
  /**
   * Represents the payment mode of the client payment used to pay for this booking.
   * Applies when a client makes a payment.
   */
  clientPaymentMode: (hotel_booking.PaymentMode|null);
  /**
   * Represents the current status of the supplier payment for this booking.
   */
  supplierPaymentStatus: hotel_booking.SupplierPaymentStatus;
  /**
   * Date of check in.
   */
  checkInDate: common.LocalDate;
  /**
   * Date of check out.
   */
  checkOutDate: common.LocalDate;
  /**
   * Payment due date.
   */
  paymentDueDate: common.LocalDate;
  /**
   * Standard special requests (empty if none).
   */
  specialRequests: hotel_booking.StandardSpecialRequest[];
  /**
   * Details of all the people staying in the booked rooms
   */
  rooms: hotel_booking.RoomOccupancyDetails[];
  /**
   * A concatenation of the first names of all the room occupants (converted to
   * lower case), used for the booking search
   */
  roomOccupantsFirstNameSearchString: string;
  /**
   * A concatenation of the last names of all the room occupants (converted to
   * lower case), used for the booking search
   */
  roomOccupantsLastNameSearchString: string;
  /**
   * Used to flag when the user has requested a cancellation
   * but there has been a failure or error cancelling the
   * booking with the supplier.
   */
  isCancellationFailed: boolean;
  /**
   * Used to flag if the booking has been confirmed and agency
   * payment is required within 24 hours. This happens when
   * confirmation of the booking is successful with the supplier
   * but payment has failed or aborted.
   */
  isPaymentPending: boolean;
  /**
   * Cancellation policy of booking.
   */
  cancellationPolicy: hotel_common.PackageCancellationPolicy;
  /**
   * Optional agent reference as a string.
   */
  agentRef: (string|null);
  /**
   * When booking was paid by client
   */
  paidOn: (common.Instant|null);
  /**
   * Booking specific commission percentage.
   */
  commissionPercentage: common.BigDecimal;
  /**
   * Date booking was last updated.
   */
  lastUpdated: common.Instant;
  /**
   * Date booking was created.
   */
  created: common.Instant;
}

export function makeBooking(
  input: {
    bookingNumber: common_strings.StringNE,
    hotelDetails: hotel_booking.HotelDetails,
    itineraryId: common_db.DbKey<Itinerary>,
    supplierId: hotel_common.SupplierId,
    supplierHotelId: hotel_common.SupplierHotelId,
    hotelId: hotel_common.HotelId,
    supplierBookingInfo?: ({}|null|null),
    supplierHotelRoomId: (string|null),
    hotelRoomId: (hotel_common.HotelRoomId|null),
    roomName: common_strings.StringNE,
    board: hotel_booking.Board,
    liveStatus: hotel_booking.LiveStatus,
    clientPaymentStatus: hotel_booking.ClientPaymentStatus,
    clientPaymentMode: (hotel_booking.PaymentMode|null),
    supplierPaymentStatus: hotel_booking.SupplierPaymentStatus,
    checkInDate: common.LocalDate,
    checkOutDate: common.LocalDate,
    paymentDueDate: common.LocalDate,
    specialRequests: hotel_booking.StandardSpecialRequest[],
    rooms: hotel_booking.RoomOccupancyDetails[],
    roomOccupantsFirstNameSearchString: string,
    roomOccupantsLastNameSearchString: string,
    isCancellationFailed?: boolean,
    isPaymentPending?: boolean,
    cancellationPolicy: hotel_common.PackageCancellationPolicy,
    agentRef: (string|null),
    paidOn: (common.Instant|null),
    commissionPercentage: common.BigDecimal,
    lastUpdated: common.Instant,
    created: common.Instant,
  }
): Booking {
  return {
    bookingNumber: input.bookingNumber,
    hotelDetails: input.hotelDetails,
    itineraryId: input.itineraryId,
    supplierId: input.supplierId,
    supplierHotelId: input.supplierHotelId,
    hotelId: input.hotelId,
    supplierBookingInfo: input.supplierBookingInfo === undefined ? null : input.supplierBookingInfo,
    supplierHotelRoomId: input.supplierHotelRoomId,
    hotelRoomId: input.hotelRoomId,
    roomName: input.roomName,
    board: input.board,
    liveStatus: input.liveStatus,
    clientPaymentStatus: input.clientPaymentStatus,
    clientPaymentMode: input.clientPaymentMode,
    supplierPaymentStatus: input.supplierPaymentStatus,
    checkInDate: input.checkInDate,
    checkOutDate: input.checkOutDate,
    paymentDueDate: input.paymentDueDate,
    specialRequests: input.specialRequests,
    rooms: input.rooms,
    roomOccupantsFirstNameSearchString: input.roomOccupantsFirstNameSearchString,
    roomOccupantsLastNameSearchString: input.roomOccupantsLastNameSearchString,
    isCancellationFailed: input.isCancellationFailed === undefined ? false : input.isCancellationFailed,
    isPaymentPending: input.isPaymentPending === undefined ? false : input.isPaymentPending,
    cancellationPolicy: input.cancellationPolicy,
    agentRef: input.agentRef,
    paidOn: input.paidOn,
    commissionPercentage: input.commissionPercentage,
    lastUpdated: input.lastUpdated,
    created: input.created,
  };
}

const Booking_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["itineraryId","supplierId","supplierHotelId","hotelId","hotelRoomId"]],"uniquenessConstraints":[["bookingNumber"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a booking on an itinerary.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Generated unique short booking number\n"}],"serializedName":"bookingNumber","default":{"kind":"nothing"},"name":"bookingNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details about hotel.\n"}],"serializedName":"hotelDetails","default":{"kind":"nothing"},"name":"hotelDetails","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"HotelDetails"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of itinerary this booking is associated with.\n"}],"serializedName":"itineraryId","default":{"kind":"nothing"},"name":"itineraryId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Itinerary"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of supplier for this hotel to generate link to supplier page\non IDS for backoffice users.\n"}],"serializedName":"supplierId","default":{"kind":"nothing"},"name":"supplierId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"SupplierId"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supplier hotel id which can be used to generate a link to the\nsupplier hotel page on IDS (with the supplierId).\n"}],"serializedName":"supplierHotelId","default":{"kind":"nothing"},"name":"supplierHotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"SupplierHotelId"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of hotel to generate link to hotel page on IDS for backoffice users.\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"HotelId"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Contains supplier information about this booking, i.e booking ID,\nreference, etc. Present if the booking is confirmed\n"}],"serializedName":"supplierBookingInfo","default":{"kind":"just","value":null},"name":"supplierBookingInfo","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supplier room id\nNote: Despite Gimmonix documentation, there is no Room Id. There is only Package Id and\nPackageRoom Id which are generated ids. The roomKey seems to be the only id we can use to\nrefresh and pay for an existing draft/quote booking in different hotel searches. The roomKey\nis optional as there might not exist one in Gimmonix packages\n"}],"serializedName":"supplierHotelRoomId","default":{"kind":"nothing"},"name":"supplierHotelRoomId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of hotel room, if we have been able to match this room to the one the supplier\nprovided.\n"}],"serializedName":"hotelRoomId","default":{"kind":"nothing"},"name":"hotelRoomId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"HotelRoomId"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of room (from supplier).\n"}],"serializedName":"roomName","default":{"kind":"nothing"},"name":"roomName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Board description e.g. Room Only, Breakfast Included etc.\n"}],"serializedName":"board","default":{"kind":"nothing"},"name":"board","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"Board"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents the current status of this booking.\n"}],"serializedName":"liveStatus","default":{"kind":"nothing"},"name":"liveStatus","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"LiveStatus"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents the current status of the client payment for this booking.\n"}],"serializedName":"clientPaymentStatus","default":{"kind":"nothing"},"name":"clientPaymentStatus","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"ClientPaymentStatus"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents the payment mode of the client payment used to pay for this booking.\nApplies when a client makes a payment.\n"}],"serializedName":"clientPaymentMode","default":{"kind":"nothing"},"name":"clientPaymentMode","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"PaymentMode"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents the current status of the supplier payment for this booking.\n"}],"serializedName":"supplierPaymentStatus","default":{"kind":"nothing"},"name":"supplierPaymentStatus","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"SupplierPaymentStatus"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Date of check in.\n"}],"serializedName":"checkInDate","default":{"kind":"nothing"},"name":"checkInDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Date of check out.\n"}],"serializedName":"checkOutDate","default":{"kind":"nothing"},"name":"checkOutDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Payment due date.\n"}],"serializedName":"paymentDueDate","default":{"kind":"nothing"},"name":"paymentDueDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Standard special requests (empty if none).\n"}],"serializedName":"specialRequests","default":{"kind":"nothing"},"name":"specialRequests","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"StandardSpecialRequest"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details of all the people staying in the booked rooms\n"}],"serializedName":"rooms","default":{"kind":"nothing"},"name":"rooms","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"RoomOccupancyDetails"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A concatenation of the first names of all the room occupants (converted to\nlower case), used for the booking search\n"}],"serializedName":"roomOccupantsFirstNameSearchString","default":{"kind":"nothing"},"name":"roomOccupantsFirstNameSearchString","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A concatenation of the last names of all the room occupants (converted to\nlower case), used for the booking search\n"}],"serializedName":"roomOccupantsLastNameSearchString","default":{"kind":"nothing"},"name":"roomOccupantsLastNameSearchString","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Used to flag when the user has requested a cancellation\nbut there has been a failure or error cancelling the\nbooking with the supplier.\n"}],"serializedName":"isCancellationFailed","default":{"kind":"just","value":false},"name":"isCancellationFailed","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Used to flag if the booking has been confirmed and agency\npayment is required within 24 hours. This happens when\nconfirmation of the booking is successful with the supplier\nbut payment has failed or aborted.\n"}],"serializedName":"isPaymentPending","default":{"kind":"just","value":false},"name":"isPaymentPending","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Cancellation policy of booking.\n"}],"serializedName":"cancellationPolicy","default":{"kind":"nothing"},"name":"cancellationPolicy","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PackageCancellationPolicy"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Optional agent reference as a string.\n"}],"serializedName":"agentRef","default":{"kind":"nothing"},"name":"agentRef","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When booking was paid by client\n"}],"serializedName":"paidOn","default":{"kind":"nothing"},"name":"paidOn","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Booking specific commission percentage.\n"}],"serializedName":"commissionPercentage","default":{"kind":"nothing"},"name":"commissionPercentage","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Date booking was last updated.\n"}],"serializedName":"lastUpdated","default":{"kind":"nothing"},"name":"lastUpdated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Date booking was created.\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"Booking","version":{"kind":"nothing"}}};

export const snBooking: ADL.ScopedName = {moduleName:"hotel.db", name:"Booking"};

export function texprBooking(): ADL.ATypeExpr<Booking> {
  return {value : {typeRef : {kind: "reference", value : snBooking}, parameters : []}};
}

/**
 * Log records relating to activity on a booking including quote
 * refreshes, confirmation, amendments, cancellations on a booking.
 */
export interface BookingLog {
  /**
   * Booking associated with this log record.
   */
  bookingId: common_db.DbKey<Booking>;
  /**
   * When the activity occurred.
   */
  timestamp: common.Instant;
  /**
   * The logged in user responsible (if any).
   */
  userId: common_db.DbKey<AppUser>;
  /**
   * From where the request eventuated
   */
  remoteAddress: hotel_common.IpAddress;
  /**
   * A textual description of the change.
   */
  description: string;
  /**
   * Transaction details (typically the originating request).
   */
  details: {}|null;
}

export function makeBookingLog(
  input: {
    bookingId: common_db.DbKey<Booking>,
    timestamp: common.Instant,
    userId: common_db.DbKey<AppUser>,
    remoteAddress?: hotel_common.IpAddress,
    description: string,
    details?: {}|null,
  }
): BookingLog {
  return {
    bookingId: input.bookingId,
    timestamp: input.timestamp,
    userId: input.userId,
    remoteAddress: input.remoteAddress === undefined ? "" : input.remoteAddress,
    description: input.description,
    details: input.details === undefined ? null : input.details,
  };
}

const BookingLog_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["bookingId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Log records relating to activity on a booking including quote\nrefreshes, confirmation, amendments, cancellations on a booking.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Booking associated with this log record.\n"}],"serializedName":"bookingId","default":{"kind":"nothing"},"name":"bookingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Booking"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the activity occurred.\n"}],"serializedName":"timestamp","default":{"kind":"nothing"},"name":"timestamp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The logged in user responsible (if any).\n"}],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"From where the request eventuated\n"}],"serializedName":"remoteAddress","default":{"kind":"just","value":""},"name":"remoteAddress","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"IpAddress"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A textual description of the change.\n"}],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Transaction details (typically the originating request).\n"}],"serializedName":"details","default":{"kind":"just","value":null},"name":"details","typeExpr":{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}}]}},"name":"BookingLog","version":{"kind":"nothing"}}};

export const snBookingLog: ADL.ScopedName = {moduleName:"hotel.db", name:"BookingLog"};

export function texprBookingLog(): ADL.ATypeExpr<BookingLog> {
  return {value : {typeRef : {kind: "reference", value : snBookingLog}, parameters : []}};
}

/**
 * A human readable line item reference. Corresponds to "bookingNumber-random ID"
 */
export type LineItemRef = string;

const LineItemRef_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A human readable line item reference. Corresponds to \"bookingNumber-random ID\"\n"}],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"LineItemRef","version":{"kind":"nothing"}}};

export const snLineItemRef: ADL.ScopedName = {moduleName:"hotel.db", name:"LineItemRef"};

export function texprLineItemRef(): ADL.ATypeExpr<LineItemRef> {
  return {value : {typeRef : {kind: "reference", value : snLineItemRef}, parameters : []}};
}

/**
 * Represents a line item associated with a booking.
 * A line item reflects the pricing and financial history of the item,
 * including any adjustments/amendments made to the original price,
 * payments made from the client, etc.
 */
export interface BookingLineItem {
  /**
   * Id of booking this line item is associated with.
   */
  bookingId: common_db.DbKey<Booking>;
  /**
   * Reference to use for reconciliation
   */
  lineItemRef: LineItemRef;
  /**
   * Line item type of the booking.
   */
  lineItemType: hotel_booking.LineItemType;
  /**
   * Supplier price in the currency provided by the supplier.
   */
  supplierPrice: hotel_common.PriceValue;
  /**
   * Supplier price converted to client's currency.
   */
  buyPrice: hotel_common.PriceValue;
  /**
   * Buy price plus markup.
   */
  netPrice: hotel_common.PriceValue;
  /**
   * Net price plus the client's adjustable commission.
   */
  grossPrice: hotel_common.PriceValue;
  /**
   * When the line item was created
   * The calculated markup amount based on the buy price.
   */
  markupAmount: hotel_common.PercentageAmountValue;
  /**
   * The calculated markup tax (GST) amount based on the markup.
   */
  markupTax: hotel_common.PercentageAmountValue;
  /**
   * Client's adjustable commission amount based on the net price.
   */
  commissionAmount: hotel_common.PercentageAmountValue;
  /**
   * The calculated client commission tax (GST) amount based on the commission.
   */
  commissionTax: hotel_common.PercentageAmountValue;
  created: common.Instant;
  /**
   * When the line item was last updated
   */
  lastUpdated: common.Instant;
}

export function makeBookingLineItem(
  input: {
    bookingId: common_db.DbKey<Booking>,
    lineItemRef: LineItemRef,
    lineItemType: hotel_booking.LineItemType,
    supplierPrice: hotel_common.PriceValue,
    buyPrice: hotel_common.PriceValue,
    netPrice: hotel_common.PriceValue,
    grossPrice: hotel_common.PriceValue,
    markupAmount: hotel_common.PercentageAmountValue,
    markupTax: hotel_common.PercentageAmountValue,
    commissionAmount: hotel_common.PercentageAmountValue,
    commissionTax: hotel_common.PercentageAmountValue,
    created: common.Instant,
    lastUpdated: common.Instant,
  }
): BookingLineItem {
  return {
    bookingId: input.bookingId,
    lineItemRef: input.lineItemRef,
    lineItemType: input.lineItemType,
    supplierPrice: input.supplierPrice,
    buyPrice: input.buyPrice,
    netPrice: input.netPrice,
    grossPrice: input.grossPrice,
    markupAmount: input.markupAmount,
    markupTax: input.markupTax,
    commissionAmount: input.commissionAmount,
    commissionTax: input.commissionTax,
    created: input.created,
    lastUpdated: input.lastUpdated,
  };
}

const BookingLineItem_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["bookingId"]],"uniquenessConstraints":[["lineItemRef"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a line item associated with a booking.\nA line item reflects the pricing and financial history of the item,\nincluding any adjustments/amendments made to the original price,\npayments made from the client, etc.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of booking this line item is associated with.\n"}],"serializedName":"bookingId","default":{"kind":"nothing"},"name":"bookingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Booking"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Reference to use for reconciliation\n"}],"serializedName":"lineItemRef","default":{"kind":"nothing"},"name":"lineItemRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"LineItemRef"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Line item type of the booking.\n"}],"serializedName":"lineItemType","default":{"kind":"nothing"},"name":"lineItemType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"LineItemType"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supplier price in the currency provided by the supplier.\n"}],"serializedName":"supplierPrice","default":{"kind":"nothing"},"name":"supplierPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supplier price converted to client's currency.\n"}],"serializedName":"buyPrice","default":{"kind":"nothing"},"name":"buyPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Buy price plus markup.\n"}],"serializedName":"netPrice","default":{"kind":"nothing"},"name":"netPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Net price plus the client's adjustable commission.\n"}],"serializedName":"grossPrice","default":{"kind":"nothing"},"name":"grossPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the line item was created\nThe calculated markup amount based on the buy price.\n"}],"serializedName":"markupAmount","default":{"kind":"nothing"},"name":"markupAmount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PercentageAmountValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The calculated markup tax (GST) amount based on the markup.\n"}],"serializedName":"markupTax","default":{"kind":"nothing"},"name":"markupTax","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PercentageAmountValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Client's adjustable commission amount based on the net price.\n"}],"serializedName":"commissionAmount","default":{"kind":"nothing"},"name":"commissionAmount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PercentageAmountValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The calculated client commission tax (GST) amount based on the commission.\n"}],"serializedName":"commissionTax","default":{"kind":"nothing"},"name":"commissionTax","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PercentageAmountValue"}},"parameters":[]}},{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the line item was last updated\n"}],"serializedName":"lastUpdated","default":{"kind":"nothing"},"name":"lastUpdated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"BookingLineItem","version":{"kind":"nothing"}}};

export const snBookingLineItem: ADL.ScopedName = {moduleName:"hotel.db", name:"BookingLineItem"};

export function texprBookingLineItem(): ADL.ATypeExpr<BookingLineItem> {
  return {value : {typeRef : {kind: "reference", value : snBookingLineItem}, parameters : []}};
}

/**
 * Represents the taxes and fees associated with a booking.
 */
export interface BookingTaxFee {
  /**
   * Id of booking this tax/fee record is associated with.
   */
  bookingId: common_db.DbKey<Booking>;
  /**
   * The tax/fee title as the supplier returned
   */
  feeTitle: string;
  /**
   * The decimal value and currency of the tax/fee as the supplier returned
   */
  fee: hotel_common.PriceValue;
  /**
   * Represents the tax/fee categorization type
   */
  unitType: string;
  /**
   * Represents the tax/fee repetitive type
   */
  frequencyType: string;
  /**
   * Represents if the tax/fee is included in the final price
   */
  isIncludedInPrice: boolean;
  /**
   * Represents if the tax/fee is mandatory to be paid
   */
  isMandatory: boolean;
  /**
   * Represents if the tax/fee is percentage value or an absolute value
   */
  isValuePercentage: (boolean|null);
  /**
   * When the tax/fee record was created
   */
  created: common.Instant;
}

export function makeBookingTaxFee(
  input: {
    bookingId: common_db.DbKey<Booking>,
    feeTitle: string,
    fee: hotel_common.PriceValue,
    unitType: string,
    frequencyType: string,
    isIncludedInPrice: boolean,
    isMandatory: boolean,
    isValuePercentage: (boolean|null),
    created: common.Instant,
  }
): BookingTaxFee {
  return {
    bookingId: input.bookingId,
    feeTitle: input.feeTitle,
    fee: input.fee,
    unitType: input.unitType,
    frequencyType: input.frequencyType,
    isIncludedInPrice: input.isIncludedInPrice,
    isMandatory: input.isMandatory,
    isValuePercentage: input.isValuePercentage,
    created: input.created,
  };
}

const BookingTaxFee_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["bookingId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents the taxes and fees associated with a booking.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of booking this tax/fee record is associated with.\n"}],"serializedName":"bookingId","default":{"kind":"nothing"},"name":"bookingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Booking"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The tax/fee title as the supplier returned\n"}],"serializedName":"feeTitle","default":{"kind":"nothing"},"name":"feeTitle","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The decimal value and currency of the tax/fee as the supplier returned\n"}],"serializedName":"fee","default":{"kind":"nothing"},"name":"fee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents the tax/fee categorization type\n"}],"serializedName":"unitType","default":{"kind":"nothing"},"name":"unitType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents the tax/fee repetitive type\n"}],"serializedName":"frequencyType","default":{"kind":"nothing"},"name":"frequencyType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents if the tax/fee is included in the final price\n"}],"serializedName":"isIncludedInPrice","default":{"kind":"nothing"},"name":"isIncludedInPrice","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents if the tax/fee is mandatory to be paid\n"}],"serializedName":"isMandatory","default":{"kind":"nothing"},"name":"isMandatory","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents if the tax/fee is percentage value or an absolute value\n"}],"serializedName":"isValuePercentage","default":{"kind":"nothing"},"name":"isValuePercentage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the tax/fee record was created\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"BookingTaxFee","version":{"kind":"nothing"}}};

export const snBookingTaxFee: ADL.ScopedName = {moduleName:"hotel.db", name:"BookingTaxFee"};

export function texprBookingTaxFee(): ADL.ATypeExpr<BookingTaxFee> {
  return {value : {typeRef : {kind: "reference", value : snBookingTaxFee}, parameters : []}};
}

/**
 * Session ID records, as supplied by the supplier, related to API interactions with the supplier
 */
export interface SupplierSession {
  /**
   * Booking associated with this supplier session id record.
   */
  bookingId: common_db.DbKey<Booking>;
  /**
   * Session IDs provided by the supplier. A booking can be associated with multiple sessions.
   * E.g. Bookings in the quote status that were successfully refreshed.
   */
  sessionId: string;
  /**
   * When the session id was recorded.
   */
  timestamp: common.Instant;
}

export function makeSupplierSession(
  input: {
    bookingId: common_db.DbKey<Booking>,
    sessionId: string,
    timestamp: common.Instant,
  }
): SupplierSession {
  return {
    bookingId: input.bookingId,
    sessionId: input.sessionId,
    timestamp: input.timestamp,
  };
}

const SupplierSession_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["bookingId"]],"uniquenessConstraints":[["bookingId","sessionId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Session ID records, as supplied by the supplier, related to API interactions with the supplier\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Booking associated with this supplier session id record.\n"}],"serializedName":"bookingId","default":{"kind":"nothing"},"name":"bookingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Booking"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Session IDs provided by the supplier. A booking can be associated with multiple sessions.\nE.g. Bookings in the quote status that were successfully refreshed.\n"}],"serializedName":"sessionId","default":{"kind":"nothing"},"name":"sessionId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the session id was recorded.\n"}],"serializedName":"timestamp","default":{"kind":"nothing"},"name":"timestamp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"SupplierSession","version":{"kind":"nothing"}}};

export const snSupplierSession: ADL.ScopedName = {moduleName:"hotel.db", name:"SupplierSession"};

export function texprSupplierSession(): ADL.ATypeExpr<SupplierSession> {
  return {value : {typeRef : {kind: "reference", value : snSupplierSession}, parameters : []}};
}

export interface BookingContext {
  userId: common_db.DbKey<AppUser>;
  bookingId: common_db.DbKey<Booking>;
  packageId: (string|null);
  priceToken: (string|null);
}

export function makeBookingContext(
  input: {
    userId: common_db.DbKey<AppUser>,
    bookingId: common_db.DbKey<Booking>,
    packageId: (string|null),
    priceToken: (string|null),
  }
): BookingContext {
  return {
    userId: input.userId,
    bookingId: input.bookingId,
    packageId: input.packageId,
    priceToken: input.priceToken,
  };
}

const BookingContext_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"bookingId","default":{"kind":"nothing"},"name":"bookingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Booking"}},"parameters":[]}]}},{"annotations":[],"serializedName":"packageId","default":{"kind":"nothing"},"name":"packageId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"priceToken","default":{"kind":"nothing"},"name":"priceToken","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"BookingContext","version":{"kind":"nothing"}}};

export const snBookingContext: ADL.ScopedName = {moduleName:"hotel.db", name:"BookingContext"};

export function texprBookingContext(): ADL.ATypeExpr<BookingContext> {
  return {value : {typeRef : {kind: "reference", value : snBookingContext}, parameters : []}};
}

/**
 * Represents a payment made or received to agentus. Used as a reconciliation
 * record with financial systems
 */
export interface Payment {
  /**
   * Collection of line item reference numbers that this payment relates to
   */
  lineItemRefs: LineItemRef[];
  /**
   * The type of payment
   */
  paymentType: PaymentType;
  /**
   * The amount of payment, negative values represent refunds
   */
  amount: hotel_common.PriceValue;
  /**
   * When the payment was created
   */
  created: common.Instant;
  /**
   * When the payment was last updated
   */
  lastUpdated: common.Instant;
  /**
   * Payment status.
   */
  status: hotel_booking.BookingPaymentStatus;
  /**
   * Payment provider (gateway)
   */
  provider: string;
  /**
   * The associated external transaction ID
   */
  transactionRef: hotel_booking.TransactionRef;
  /**
   * Associated booking context
   */
  bookingContext: BookingContext;
}

export function makePayment(
  input: {
    lineItemRefs: LineItemRef[],
    paymentType: PaymentType,
    amount: hotel_common.PriceValue,
    created: common.Instant,
    lastUpdated: common.Instant,
    status: hotel_booking.BookingPaymentStatus,
    provider: string,
    transactionRef: hotel_booking.TransactionRef,
    bookingContext: BookingContext,
  }
): Payment {
  return {
    lineItemRefs: input.lineItemRefs,
    paymentType: input.paymentType,
    amount: input.amount,
    created: input.created,
    lastUpdated: input.lastUpdated,
    status: input.status,
    provider: input.provider,
    transactionRef: input.transactionRef,
    bookingContext: input.bookingContext,
  };
}

const Payment_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["transactionRef"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a payment made or received to agentus. Used as a reconciliation\nrecord with financial systems\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Collection of line item reference numbers that this payment relates to\n"}],"serializedName":"lineItemRefs","default":{"kind":"nothing"},"name":"lineItemRefs","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"LineItemRef"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The type of payment\n"}],"serializedName":"paymentType","default":{"kind":"nothing"},"name":"paymentType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"PaymentType"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The amount of payment, negative values represent refunds\n"}],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the payment was created\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the payment was last updated\n"}],"serializedName":"lastUpdated","default":{"kind":"nothing"},"name":"lastUpdated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Payment status.\n"}],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"BookingPaymentStatus"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Payment provider (gateway)\n"}],"serializedName":"provider","default":{"kind":"nothing"},"name":"provider","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The associated external transaction ID\n"}],"serializedName":"transactionRef","default":{"kind":"nothing"},"name":"transactionRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"TransactionRef"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Associated booking context\n"}],"serializedName":"bookingContext","default":{"kind":"nothing"},"name":"bookingContext","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"BookingContext"}},"parameters":[]}}]}},"name":"Payment","version":{"kind":"nothing"}}};

export const snPayment: ADL.ScopedName = {moduleName:"hotel.db", name:"Payment"};

export function texprPayment(): ADL.ATypeExpr<Payment> {
  return {value : {typeRef : {kind: "reference", value : snPayment}, parameters : []}};
}

export enum LogType {
  requiresAuthorize,
  authorized,
  captured,
  cancelled,
  failed,
}

const LogType_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"requiresAuthorize","default":{"kind":"nothing"},"name":"requiresAuthorize","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"authorized","default":{"kind":"nothing"},"name":"authorized","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"captured","default":{"kind":"nothing"},"name":"captured","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"cancelled","default":{"kind":"nothing"},"name":"cancelled","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"failed","default":{"kind":"nothing"},"name":"failed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"LogType","version":{"kind":"nothing"}}};

export const snLogType: ADL.ScopedName = {moduleName:"hotel.db", name:"LogType"};

export function texprLogType(): ADL.ATypeExpr<LogType> {
  return {value : {typeRef : {kind: "reference", value : snLogType}, parameters : []}};
}

/**
 * Represents payment changes during the charging.
 */
export interface PaymentTransactionLog {
  /**
   * External log/event ID
   */
  externalId: string;
  /**
   * Parent payment
   */
  paymentId: common_db.DbKey<Payment>;
  /**
   * Transaction log type
   */
  logType: LogType;
  /**
   * Short description
   */
  description: common_strings.StringNE;
  /**
   * External payment details
   */
  details: {}|null;
  /**
   * The time at which the payment was made
   */
  created: common.Instant;
}

export function makePaymentTransactionLog(
  input: {
    externalId: string,
    paymentId: common_db.DbKey<Payment>,
    logType: LogType,
    description: common_strings.StringNE,
    details: {}|null,
    created: common.Instant,
  }
): PaymentTransactionLog {
  return {
    externalId: input.externalId,
    paymentId: input.paymentId,
    logType: input.logType,
    description: input.description,
    details: input.details,
    created: input.created,
  };
}

const PaymentTransactionLog_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents payment changes during the charging.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"External log/event ID\n"}],"serializedName":"externalId","default":{"kind":"nothing"},"name":"externalId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Parent payment\n"}],"serializedName":"paymentId","default":{"kind":"nothing"},"name":"paymentId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Payment"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Transaction log type\n"}],"serializedName":"logType","default":{"kind":"nothing"},"name":"logType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"LogType"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Short description\n"}],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"External payment details\n"}],"serializedName":"details","default":{"kind":"nothing"},"name":"details","typeExpr":{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The time at which the payment was made\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"PaymentTransactionLog","version":{"kind":"nothing"}}};

export const snPaymentTransactionLog: ADL.ScopedName = {moduleName:"hotel.db", name:"PaymentTransactionLog"};

export function texprPaymentTransactionLog(): ADL.ATypeExpr<PaymentTransactionLog> {
  return {value : {typeRef : {kind: "reference", value : snPaymentTransactionLog}, parameters : []}};
}

export enum PaymentType {
  client,
  supplier,
}

const PaymentType_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"client","default":{"kind":"nothing"},"name":"client","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"supplier","default":{"kind":"nothing"},"name":"supplier","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"PaymentType","version":{"kind":"nothing"}}};

export const snPaymentType: ADL.ScopedName = {moduleName:"hotel.db", name:"PaymentType"};

export function texprPaymentType(): ADL.ATypeExpr<PaymentType> {
  return {value : {typeRef : {kind: "reference", value : snPaymentType}, parameters : []}};
}

/**
 * Represents Terms and Conditions content.
 */
export interface TermsAndConditions {
  /**
   * The T&C content version
   */
  version: number;
  /**
   * The T&C content
   */
  content: common_strings.StringNE;
  /**
   * The time at which the T&C was created.
   */
  created: common.Instant;
}

export function makeTermsAndConditions(
  input: {
    version: number,
    content: common_strings.StringNE,
    created: common.Instant,
  }
): TermsAndConditions {
  return {
    version: input.version,
    content: input.content,
    created: input.created,
  };
}

const TermsAndConditions_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents Terms and Conditions content.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The T&C content version\n"}],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The T&C content\n"}],"serializedName":"content","default":{"kind":"nothing"},"name":"content","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The time at which the T&C was created.\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"TermsAndConditions","version":{"kind":"nothing"}}};

export const snTermsAndConditions: ADL.ScopedName = {moduleName:"hotel.db", name:"TermsAndConditions"};

export function texprTermsAndConditions(): ADL.ATypeExpr<TermsAndConditions> {
  return {value : {typeRef : {kind: "reference", value : snTermsAndConditions}, parameters : []}};
}

export type BookingRef = string;

const BookingRef_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"BookingRef","version":{"kind":"nothing"}}};

export const snBookingRef: ADL.ScopedName = {moduleName:"hotel.db", name:"BookingRef"};

export function texprBookingRef(): ADL.ATypeExpr<BookingRef> {
  return {value : {typeRef : {kind: "reference", value : snBookingRef}, parameters : []}};
}

/**
 * Represents a comment for an itinerary.
 */
export interface ItineraryComment {
  /**
   * Parent itinerary
   */
  itineraryId: common_db.DbKey<Itinerary>;
  /**
   * Comment owner
   */
  ownerId: common_db.DbKey<AppUser>;
  /**
   * Comment text
   */
  commentText: common_strings.StringNE;
  /**
   * Related booking numbers
   */
  bookingRefs: BookingRef[];
  /**
   * Creation time
   */
  created: common.Instant;
}

export function makeItineraryComment(
  input: {
    itineraryId: common_db.DbKey<Itinerary>,
    ownerId: common_db.DbKey<AppUser>,
    commentText: common_strings.StringNE,
    bookingRefs: BookingRef[],
    created: common.Instant,
  }
): ItineraryComment {
  return {
    itineraryId: input.itineraryId,
    ownerId: input.ownerId,
    commentText: input.commentText,
    bookingRefs: input.bookingRefs,
    created: input.created,
  };
}

const ItineraryComment_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a comment for an itinerary.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Parent itinerary\n"}],"serializedName":"itineraryId","default":{"kind":"nothing"},"name":"itineraryId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Itinerary"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Comment owner\n"}],"serializedName":"ownerId","default":{"kind":"nothing"},"name":"ownerId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Comment text\n"}],"serializedName":"commentText","default":{"kind":"nothing"},"name":"commentText","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Related booking numbers\n"}],"serializedName":"bookingRefs","default":{"kind":"nothing"},"name":"bookingRefs","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"BookingRef"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Creation time\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ItineraryComment","version":{"kind":"nothing"}}};

export const snItineraryComment: ADL.ScopedName = {moduleName:"hotel.db", name:"ItineraryComment"};

export function texprItineraryComment(): ADL.ATypeExpr<ItineraryComment> {
  return {value : {typeRef : {kind: "reference", value : snItineraryComment}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "hotel.db.AppUser" : AppUser_AST,
  "hotel.db.UserStatus" : UserStatus_AST,
  "hotel.db.AppUserId" : AppUserId_AST,
  "hotel.db.AppUserType" : AppUserType_AST,
  "hotel.db.AppUserLog" : AppUserLog_AST,
  "hotel.db.HeadOffice" : HeadOffice_AST,
  "hotel.db.Agency" : Agency_AST,
  "hotel.db.AgencyLog" : AgencyLog_AST,
  "hotel.db.Itinerary" : Itinerary_AST,
  "hotel.db.ItineraryLog" : ItineraryLog_AST,
  "hotel.db.ItineraryNumber" : ItineraryNumber_AST,
  "hotel.db.Booking" : Booking_AST,
  "hotel.db.BookingLog" : BookingLog_AST,
  "hotel.db.LineItemRef" : LineItemRef_AST,
  "hotel.db.BookingLineItem" : BookingLineItem_AST,
  "hotel.db.BookingTaxFee" : BookingTaxFee_AST,
  "hotel.db.SupplierSession" : SupplierSession_AST,
  "hotel.db.BookingContext" : BookingContext_AST,
  "hotel.db.Payment" : Payment_AST,
  "hotel.db.LogType" : LogType_AST,
  "hotel.db.PaymentTransactionLog" : PaymentTransactionLog_AST,
  "hotel.db.PaymentType" : PaymentType_AST,
  "hotel.db.TermsAndConditions" : TermsAndConditions_AST,
  "hotel.db.BookingRef" : BookingRef_AST,
  "hotel.db.ItineraryComment" : ItineraryComment_AST
};
